import React from 'react';
import { Table } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import AuthorizedAction from '../../../AuthorizedAction.js';
import PermissionsTableRow from './PermissionsTableRow.jsx';

const PermissionsTable = ({ slug, roles, userId, currentUserId }) => (
  <Table hover className="permissions-table">
    <thead>
      <tr>
        <th>{getOrgTermsContent('project')}</th>
        <th>{getOrgTermsContent('project')} Role(s)</th>
        <th>Group(s) and Group Role(s)</th>
        {userId !== currentUserId ? (
          <AuthorizedAction action="update" subject="userProjectRole">
            <th>Actions</th>
          </AuthorizedAction>
        ) : null}
      </tr>
    </thead>
    <tbody>
      {roles.map((role) => (
        <PermissionsTableRow
          key={role.id}
          slug={slug}
          {...role}
          userId={userId}
          currentUserId={currentUserId}
        />
      ))}
    </tbody>
  </Table>
);

export default PermissionsTable;
